import { render, staticRenderFns } from "./PartEditor.vue?vue&type=template&id=38a69580&"
import script from "./PartEditor.vue?vue&type=script&lang=ts&"
export * from "./PartEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PartEditor.vue?vue&type=style&index=0&id=38a69580&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports